import React from 'react';
import { FaEllipsisV } from 'react-icons/fa';
import { connect } from 'react-redux';
import { CardDDListOptions } from '../../../../assets/constants/strings';

const CardOptions = ({ index, isDefault, handleOption, cards }) => {
  return (
    <div className="payment-card__options dropdown">
      <div
        id={`card-options-dropdown-${index}`}
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        title="Actions"
      >
        <FaEllipsisV className="payment-card__options__icon" />
      </div>
      <div className="dropdown-menu dropdown-menu-right" aria-labelledby={`#card-options-dropdown-${index}`}>
        {CardDDListOptions.map((option, i) => (
          <div
            key={i}
            className={`dropdown-item active-override${{
              0: isDefault ? ' disabled' : '',
              2: isDefault || cards.length === 1 ? ' disabled' : '',
            }[i] || ''}`}
            title={{
              0: isDefault ? 'Already your Default' : option.text,
              2: isDefault ? 'Cannot delete Default payment method' : cards.length === 1 ? 'Cannot delete only card available' : option.text,
            }[i] || option.text}
            onClick={() => handleOption(option.value)}
          >
            {option.icon} {option.text}
          </div>
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  cards: state.user.cards,
});

export default connect(mapStateToProps)(CardOptions);
